import { CommonModule } from '@angular/common';
import { Component, ElementRef, HostListener, Input, ViewChild } from '@angular/core';
import { CoreModule } from 'app/core/core.module';
import { WaitingInLinePass } from 'app/models/WaitInLine';
import { WaitInLineFavicon } from 'app/pass-cards/wait-in-line-card/wait-in-line-card.component';
import { RoomIconComponent } from 'app/room-icon/room-icon.component';
import { hexToRGBAWithAdjustments } from '../../colorCalc';
import { HallPass, PassLike } from '../models';
import { WaitInLineService } from '../services/wait-in-line.service';

@Component({
	selector: 'sp-student-pass-info',
	templateUrl: './student-pass-info.component.html',
	styleUrls: ['./student-pass-info.component.scss'],
	standalone: true,
	imports: [CommonModule, CoreModule, RoomIconComponent],
})
export class StudentPassInfoComponent {
	@Input() pass!: PassLike;
	@Input() passType = '';
	@ViewChild('mainBody', { static: false }) mainBody: ElementRef<HTMLDivElement> | undefined;

	@HostListener('mouseenter')
	onMouseEnter(): void {
		if (!this.mainBody) {
			return;
		}
		try {
			this.mainBody.nativeElement.style.background = hexToRGBAWithAdjustments(this.pass?.color_profile?.solid_color, 0, 0, -5, 1);
		} catch {
			console.warn('failed to apply background color');
		}
	}

	@HostListener('mouseleave')
	onMouseLeave(): void {
		if (!this.mainBody) {
			return;
		}
		try {
			this.mainBody.nativeElement.style.background = this.pass?.color_profile?.solid_color;
		} catch {
			console.warn('failed to revert background color');
		}
	}

	acceptingPassTimeRemaining = 0;

	constructor(private wilService: WaitInLineService) {}

	get remainingAttemptSeconds(): number {
		return this.wilService.remainingAttemptSeconds(this.pass as WaitingInLinePass);
	}

	protected isPass(pass: PassLike): pass is HallPass {
		return pass instanceof HallPass;
	}

	protected isWaitingInLinePass(pass: PassLike): pass is WaitingInLinePass {
		return pass instanceof WaitingInLinePass;
	}

	private changeTitle(tabTitle: string): void {
		return this.wilService.setTabTitleForWilp(tabTitle);
	}

	private changeFavicon(assetLink: string): void {
		this.wilService.changeFaviconForWilp(assetLink);
	}

	readyToStartTick(remainingTime: number): void {
		this.acceptingPassTimeRemaining = remainingTime;
		if (remainingTime > 27) {
			this.changeTitle('Time to Start Your Pass');
			this.changeFavicon(WaitInLineFavicon.FrontOfLine);
			setTimeout(() => {
				this.changeFavicon(WaitInLineFavicon.Transparent);
			}, 400);
			return;
		}

		if (remainingTime === 0 && this.pass instanceof WaitingInLinePass && this.pass.missed_start_attempts > 0) {
			this.changeFavicon('./assets/icons/favicon.ico');
			return;
		}

		if (remainingTime % 2 === 0) {
			this.changeTitle(`${remainingTime} sec left...`);
			this.changeFavicon(WaitInLineFavicon.HourglassToggle1);
		} else {
			this.changeTitle(`${remainingTime} sec left...`);
			this.changeFavicon(WaitInLineFavicon.HourglassToggle2);
		}
	}
}
